import React from 'react';
import { useNavigate } from 'react-router-dom';

const TermsOfService = () => {
  const navigate = useNavigate();

  return (
    <div className="page-content">
      <div className="policy-page">
        <button 
          className="btn outline" 
          onClick={() => navigate(-1)}
          style={{ marginBottom: '2rem' }}
        >
          ← Back
        </button>
        
        <div className="policy-header">
          <h1 className="policy-title">📜 Terms of Service</h1>
          <p className="policy-date">Effective Date: January 14, 2025</p>
        </div>
        
        <div className="policy-content">
          <div className="policy-section">
            <p>By accessing or using NeoTeeForge (https://shop.neoteeforge.com), you agree to be bound by these Terms of Service. Please read them carefully before using our services.</p>
          </div>

          <div className="policy-section">
            <h3>1. Acceptance of Terms</h3>
            <p>By creating an account, browsing, or making a purchase on our website, you acknowledge that you have read, understood, and agree to be bound by these terms. If you disagree with any part, please do not use our services.</p>
          </div>

          <div className="policy-section">
            <h3>2. User Accounts</h3>
            <p>When you create an account, you must:</p>
            <ul className="policy-list">
              <li>Provide accurate and complete information</li>
              <li>Maintain the security of your password</li>
              <li>Notify us immediately of any unauthorized access</li>
              <li>Be at least 18 years old or have parental consent</li>
            </ul>
            <p>You are responsible for all activities under your account.</p>
          </div>

          <div className="policy-section">
            <h3>3. Products & Usage</h3>
            <h4>Digital Products (eBooks, PDFs, Digital Downloads):</h4>
            <ul className="policy-list">
              <li><strong>All digital products are for personal use only</strong></li>
              <li>Redistribution, resale, or sharing of digital files is strictly prohibited</li>
              <li>You may download purchased content on up to 3 devices</li>
              <li>DRM-protected content has additional usage restrictions</li>
            </ul>
            
            <h4>Physical Products (Books, Merchandise):</h4>
            <ul className="policy-list">
              <li>Products are subject to availability</li>
              <li>Images on the website are for illustrative purposes</li>
              <li>Actual products may vary slightly from images</li>
              <li>Physical books are for personal reading only</li>
            </ul>
          </div>

          <div className="policy-section">
            <h3>4. Orders & Payments</h3>
            <ul className="policy-list">
              <li>All prices are listed clearly on the website in your selected currency</li>
              <li>Prices are subject to change without notice</li>
              <li>Payments must be completed before order processing begins</li>
              <li>We accept various payment methods as displayed during checkout</li>
              <li>We reserve the right to refuse or cancel orders in case of:</li>
              <ul className="policy-list" style={{ marginLeft: '1rem' }}>
                <li>Suspected fraud or misuse</li>
                <li>Pricing errors</li>
                <li>Product unavailability</li>
                <li>Violation of these terms</li>
              </ul>
              <li>Orders are processed within 1-2 business days</li>
            </ul>
          </div>

          <div className="policy-section">
            <h3>5. Intellectual Property</h3>
            <p>All content on NeoTeeForge, including but not limited to:</p>
            <ul className="policy-list">
              <li>Website design, layout, and structure</li>
              <li>Text, images, graphics, and logos</li>
              <li>Digital products and their content</li>
              <li>Brand names and trademarks</li>
            </ul>
            <p>are the exclusive property of NeoTeeForge or our licensors. You may not copy, reproduce, modify, distribute, or create derivative works without explicit written permission.</p>
          </div>

          <div className="policy-section">
            <h3>6. User Conduct</h3>
            <p>You agree not to:</p>
            <ul className="policy-list">
              <li>Use our services for any illegal purpose</li>
              <li>Attempt to gain unauthorized access to our systems</li>
              <li>Interfere with the proper working of our website</li>
              <li>Upload viruses or malicious code</li>
              <li>Use automated systems to access our services without permission</li>
              <li>Harass, abuse, or harm other users</li>
              <li>Share your account credentials</li>
            </ul>
          </div>

          <div className="policy-section">
            <h3>7. Limitation of Liability</h3>
            <p>NeoTeeForge and its affiliates shall not be liable for:</p>
            <ul className="policy-list">
              <li>Indirect, incidental, or consequential damages</li>
              <li>Loss of data, profits, or business opportunities</li>
              <li>Misuse of products by users</li>
              <li>Actions of third-party service providers</li>
              <li>Technical issues beyond our reasonable control</li>
              <li>Content accuracy in user reviews or third-party links</li>
            </ul>
            <p>Our total liability shall not exceed the amount you paid for the product in question.</p>
          </div>

          <div className="policy-section">
            <h3>8. Termination</h3>
            <p>We may suspend or terminate your account at our discretion if you violate these terms. Upon termination, you must cease all use of our services and destroy any downloaded materials.</p>
          </div>

          <div className="policy-section">
            <h3>9. Changes to Terms</h3>
            <p>We reserve the right to modify these terms at any time. Changes will be effective immediately upon posting. Your continued use of our services constitutes acceptance of the modified terms.</p>
          </div>

          <div className="policy-section">
            <h3>10. Contact Information</h3>
            <p>For questions about these Terms of Service:</p>
            <div style={{ background: '#f8fafc', padding: '1rem', borderRadius: '8px', marginTop: '1rem' }}>
              <p><strong>📧 Email:</strong> support@neoteeforge.com</p>
              <p><strong>🌐 Website:</strong> https://shop.neoteeforge.com</p>
              <p><strong>⏰ Business Hours:</strong> Monday-Friday, 9 AM - 6 PM IST</p>
            </div>
          </div>

          <div style={{ marginTop: '3rem', paddingTop: '2rem', borderTop: '1px solid #e2e8f0' }}>
            <p style={{ fontSize: '0.9rem', color: '#64748b' }}>
              <strong>Note:</strong> These terms apply to all users of NeoTeeForge services, including customers, visitors, and registered members.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;